import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFlag2"><Path d="M11.7277 15.9625C9.66439 15.3786 7.92507 14.9119 6 15.6511V22.0003H4V3.38105L4.55434 3.10508C7.43846 1.66927 10.001 2.39492 12.1859 3.01361L12.2723 3.03807C14.5317 3.67746 16.4026 4.17628 18.5543 3.10508L20 2.38539V15.6195L19.4457 15.8955C16.5615 17.3313 13.999 16.6056 11.8141 15.987L11.7277 15.9625Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag2;
